import { useTranslation } from 'react-i18next';
import { ZIP_OBJECT_TYPES, isZipObjectType, type ZipObjectType } from '@/lib/referral/referralAttachments';
import { FORM_HINT_TYPE, FORM_LABEL_TYPE } from '@/lib/typography';

/**
 * BIN01-S 3.3: a zip file "kan kvalificeres med alle ObjectCode" (XBIN02 p. 23), so the
 * clinician says what the archive holds. The choice becomes the XBIN02 ObjectCode.
 */
export function ZipContentSelect({
  id,
  value,
  disabled,
  onChange,
}: {
  id: string;
  value: ZipObjectType | undefined;
  disabled?: boolean;
  onChange: (value: ZipObjectType | undefined) => void;
}) {
  const { t } = useTranslation();
  const label = (type: ZipObjectType): string => {
    switch (type) {
      case 'TXT':
        return t('patients.hospital_referral.zip_type_txt', 'Tekst og tabeller (tekstfil)');
      case 'IMG':
        return t('patients.hospital_referral.zip_type_img', 'Billeder (billede)');
      case 'VGR':
        return t('patients.hospital_referral.zip_type_vgr', 'Vektorgrafik, fx PDF (vektor_grafik)');
      case 'BSG':
        return t('patients.hospital_referral.zip_type_bsg', 'Biosignaler, fx EKG (biosignaler)');
      case 'MUL':
        return t('patients.hospital_referral.zip_type_mul', 'Lyd og video (multimedie)');
    }
  };
  return (
    <label htmlFor={id} className="block">
      <span className={FORM_LABEL_TYPE}>
        {t('patients.hospital_referral.zip_type_label', 'Indhold i ZIP-filen')}
      </span>
      <select
        id={id}
        value={value ?? ''}
        disabled={disabled}
        onChange={(event) => {
          const next = event.target.value;
          onChange(isZipObjectType(next) ? next : undefined);
        }}
        className="mt-1 block w-full rounded-lg border border-ds-field px-3 py-2 text-sm shadow-card focus:border-ds-teal focus:outline-none focus:ring-1 focus:ring-ds-teal"
      >
        <option value="">{t('patients.hospital_referral.zip_type_choose', 'Vælg indhold')}</option>
        {ZIP_OBJECT_TYPES.map((type) => (
          <option key={type} value={type}>
            {label(type)}
          </option>
        ))}
      </select>
      <span className={FORM_HINT_TYPE}>
        {t(
          'patients.hospital_referral.zip_type_hint',
          'En ZIP-fil sendes med den valgte indholdstype (ObjectCode).',
        )}
      </span>
    </label>
  );
}
